/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import FirstView from '../../asset/firstview.png';
import TheLayout from '../../layout/TheLayout';
import NavSidebar from '../Util/NavSidebar/NavSidebar';
import interviewImg1 from '../../asset/Interviews/Interview03/interview03_1.jpg';
import interviewImg2 from '../../asset/Interviews/Interview03/interview03_2.jpg';
import './interview_article.css';

const keywords = ['TERRA', 'TERRA FORESTA', 'TERRA COAT', '株式会社TERRA', 'TERRA株式会社', '光触媒'];

const Interview03 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const conversations = [
    {
      question: 'TERRAの商品をご導入されたきっかけからお伺いできますか。',
      answer: `やはり、コロナがきっかけでした。<br />
      2年ほど前から導入をしているのですが、当社は今まで従業員、お客様からコロナ感染者が出ていないんです。`,
    },
    {
      question: '派遣業を行っていると多くの方と接すると思うのですが、感染者が0というのはどのような対策をとられたのでしょうか。',
      answer: `当社は全国的にスタッフが200名程います。<br />
      当社スタッフは主に、企業、工場へのマイクロバスでの送迎をする業務から、製造業の現場（工場）で働くスタッフなどがいます。<br />
      このような人数で且つマイクロバスとなると、いろいろな人が乗車されるので、当社では、マイクロバス60台程TERRAの光触媒コーティングを行い、車両ごとにTERRAの車用噴霧器を置いています。<br />
      そして、工場や事務所ごとにタワー型加湿器を置いており100台程導入致しました。`,
    },
    {
      question: 'ご導入をされてスタッフ様やお客様の反応はいかがでしたか。',
      answer: `スタッフは会社がきちんと除菌対策をとっているという安心感と除菌に対する意識が高まったと思います。<br />
      TERRAの商品でスプレータイプの除菌とパウダーを水で薄めて利用する除菌液があるのですが、皆バスの乗降の際や、事務所を行き来する度に利用するという徹底ぶりになっています。<br />
      お客様には、感染対策を説明しているのと、感染者ゼロという実績から安心と信用を得られています。<br />
      マイクロバスの感染対策について保健所等で案内しているのは、換気を良くする、パーテーションを置くなどの案内になっており、業者が独自で考え対策を行うことが必要になっています。<br />
      当社は、自社で対策を考え、いろいろな商品と比較したなか、光触媒コーティングから除菌対策商品を取り扱っているTERRAの商品を選びました。<br />
      TERRAの商品を利用したことで、スタッフやお客様の健康を守り、且つ仕事をきちんとこなすことができたので、導入して良かったと思っております。`,
    },
    {
      img: interviewImg2,
    },
    {
      question: '今後、TERRAの商品は継続してご利用していく予定ですか。',
      answer: 'はい、今回のコロナは命に関わる感染でしたので、当社は今後も光触媒コーティング、手と車内・社内の消毒、空気除菌を徹底し、トリプル除菌をして参ります。',
    },
    {
      question: 'TERRAの商品を導入して非常に良かったというご感想ですが、商品をお勧めしたい方などいますか。',
      answer: `人と多く会う機会が多い方にはお勧めしたいです。<br />
      そして、企業様にも感染対策を説明することができるので、営業のアピールにもなるのではと思います。`,
    },
    {
      question: '今後TERRAに期待されることはありますか。',
      answer: `今後も新しい株が出てくると思うのですが、新しい株にも対応がされていくという効果や、その効果が目で見てわかるようになるとより一層安心感があると思います。<br />
      そして、是非国にもTERRAの商品を認めて頂けたらなと願ってます。`,
    },
  ];

  const renderQnA = () => conversations.map((qna) => (
    <div className="row interview-qna" key={qna.question}>
      {
        qna.img
        && (
          <div className="col">
            <img src={qna.img} style={{ width: '100%' }} alt="" />
          </div>
        )
      }
      {
        qna.question
        && (
          <div className="col">
            <div className="interview-question">
              <span className="interview-question-dash" />
              {qna.question}
            </div>
            <div className="interview-answer" dangerouslySetInnerHTML={{ __html: qna.answer }} />
          </div>
        )
      }
    </div>
  ));

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>お客様の声｜株式会社TERRA</title>
      </Helmet>
      <div className="interview-introduction-detail">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          お客様の声
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>お客様の声</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="container p-0">
          <div className="row m-0">
            <div className="col-3 d-none d-lg-block p-0" style={{ background: 'white' }}>
              <NavSidebar />
            </div>
            <div className="col-12 col-lg-9 p-0">
              <div
                className="m-auto p-0 p-lg-5"
              >
                <div className="interview-post-container">
                  <h4 className="interview-post-title">
                    多くの人が行き交う数百人規模でも徹底除菌ができたTERRAの商品の魅力とは？
                  </h4>
                  <div>
                    <img src={interviewImg1} style={{ width: '100%' }} alt="VivaceImg" />
                  </div>
                  <div>
                    <div className="interview-name">
                      TERRA商品をご愛用者様ご利用の声vol,3
                    </div>
                    <div className="interview-intro">
                      ドライバー、製造、物流などの現場スタッフ派遣業をコンサルタントから行っている
                      <span>株式会社伊勢安 </span>
                      清田様にお話しをお伺い致しました。
                    </div>
                  </div>
                  <div className="interview-conversations">
                    {renderQnA(conversations)}
                  </div>
                  <div className="interview-end">
                    <p>インタビュー協力</p>
                    <p>株式会社伊勢安</p>
                    <p>清田　良春様</p>
                    <a
                      className="interview-vivace-link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.iseyasu.com/"
                      style={{ color: '#0000FF' }}
                    >
                      https://www.iseyasu.com/
                    </a>
                    <p>取材・文</p>
                    <p>ARIA株式会社　青山　綾子</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default Interview03;
